export function formatCurrency(number) {
    /**
     * formatea los precios con foramto europeo
     * 
     * params:
     *  number => int => numero que desea formatear
     * 
     * returns: 
     *  formattedNumber => str => numero formateado con puntos y comas 
     */
    if (isNaN(number)) {
      return "Invalid number";
    }
    let formattedNumber = number.toFixed(2);
    const parts = formattedNumber.split(".");
    const integerPartWithSeparator = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    formattedNumber = integerPartWithSeparator + "," + parts[1];
    formattedNumber = "€" + formattedNumber;
    return formattedNumber;
  }
  


// WEBPACK FOOTER //
// ./src/util/formatCurrency.js